import { stringify } from "query-string"
import { farasod } from "./api"

const endpoint = "/blog"

export const getBlogPosts = async (queries) => {
  const query =
    stringify(queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const response = await farasod.get(`${endpoint}/post?${query}`)

  return response.data
}

export const getBlogPost = async (postId) => {
  const response = await farasod.get(`${endpoint}/post/${postId}`)

  return response.data
}

export const addBlogPost = async (data) => {
  const response = await farasod.post(`${endpoint}/post`, data)

  return response.data
}

export const editBlogPost = async (postId, data) => {
  const response = await farasod.patch(`${endpoint}/post/${postId}`, data)

  return response.data
}

export const deleteBlogPost = async (postId) => {
  const response = await farasod.delete(`${endpoint}/post/${postId}`)

  return response.data
}

export const getBlogCategories = async (queries) => {
  const query =
    stringify(queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const response = await farasod.get(`${endpoint}/category?${query}`)

  return response.data
}

export const addBlogCategory = async (data) => {
  const response = await farasod.post(`${endpoint}/category`, data)

  return response.data
}

export const editBlogCategory = async (categoryId, data) => {
  const response = await farasod.patch(`${endpoint}/category/${categoryId}`, data)

  return response.data
}

export const deleteBlogCategory = async (categoryId) => {
  const response = await farasod.delete(`${endpoint}/category/${categoryId}`)

  return response.data
}

export const getBlogComments = async (queries) => {
  const query =
    stringify(queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const response = await farasod.get(`${endpoint}/comment?${query}`)

  return response.data
}

export const archiveBlogComment = async (commentId) => {
  const response = await farasod.patch(`${endpoint}/comment/archive/${commentId}`)

  return response.data
}


export const publishBlogComment = async (commentId) => {
  const response = await farasod.patch(`${endpoint}/comment/publish/${commentId}`)

  return response.data
}

export const deleteBlogComment = async (commentId) => {
  const response = await farasod.delete(`${endpoint}/comment/${commentId}`)

  return response.data
}

export const replyBlogComment = async (commentId, data) => {
  const response = await farasod.patch(`${endpoint}/comment/reply/${commentId}`, data)

  return response.data
}

export const getBlogTags = async (queries) => {
  const query =
    stringify(queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const response = await farasod.get(`${endpoint}/tag?${query}`)

  return response.data
}

export const addBlogTag = async (data) => {
  const response = await farasod.post(`${endpoint}/tag`, data)

  return response.data
}

export const editBlogTag = async (tagId, data) => {
  const response = await farasod.patch(`${endpoint}/tag/${tagId}`, data)

  return response.data
}

export const deleteBlogTag = async (tagId) => {
  const response = await farasod.delete(`${endpoint}/tag/${tagId}`)

  return response.data
}